module.exports = __webpack_public_path__ + "static/rectangle-479437bf6a888db5d90164b21cd66026.png";